import {
  Button,
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
} from "@material-ui/core";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideAllowedVehicleAlertModal } from "../../../store/buyPermits/action";
import SelectPhoneModalForm from "../../Forms/buypermits/SelectPhoneModalForm";
import BaseModal, { BaseModalContent } from "../BaseModal";

const AllowedVehicleAlertModal = (props) => {
  const { isOpenAllowedVehicleAlertModal, permit, vehicleLimit, onBack } = props;
  const dispatch = useDispatch();
  const [allowedNoOfVehcile, setAllowedNoOfVehcile] = React.useState(0);

  const allowedNoVehcile = useSelector(
    (state) => state?.exitOrderReducer?.allowedNumberOfVehcile
  );

  React.useEffect(() => {
    setAllowedNoOfVehcile(allowedNoVehcile);
  }, [allowedNoVehcile]);

  //    useEffect(() => {
  //     const ActiveData = emailData && emailData.filter((items) => {
  //       return items.inactive === false
  //     })
  //     setMyEmailData(ActiveData)
  //     dispatch(getCheckoutSelectPhoneStates({accountId:1337}));
  //   }, [emailData])

  const CloseAllowedVehicleAlertModal = () => {
    dispatch(hideAllowedVehicleAlertModal());
    // onBack()
  
  };


  return (
    <>
      <BaseModal
                title="Alert"
                align="center"
                open={isOpenAllowedVehicleAlertModal}
                onClose={CloseAllowedVehicleAlertModal}
                with={500}                
            >
                <BaseModalContent>
                    {/* <span>you have not allowed more than {allowedNoOfVehcile} vehicle </span> */}
                    <span>You are only allowed to select {allowedNoOfVehcile || vehicleLimit?.allowedNoVehicles} {allowedNoOfVehcile>2 ? " vehicles":" vehicle"}</span>
                    <br/><br />
                    <Button style={{float:"right", backgroundColor:"#20419a",color:"white"}} variant="contained" onClick={CloseAllowedVehicleAlertModal}>close</Button>
                </BaseModalContent>
            </BaseModal>
    </>
  );
};
export default AllowedVehicleAlertModal;
